import { defineMessages } from 'react-intl';

export default defineMessages({
    submitAddress: {
        id: 'platform.inputs.address-details.submitAddress',
        defaultMessage: 'Submit'
    },
    back: {
        id: 'platform.inputs.address-details.back',
        defaultMessage: 'Back'
    },
    acknowledgeMailingAddress: {
        id: 'tdic.endorsement.mailing-address.By checking this box, I hereby acknowledge this address is used for postal mail purposes only and will not impact the covered location on any policy.',
        defaultMessage: 'By checking this box, I hereby acknowledge this address is used for postal mail purposes only and will not impact the covered location on any policy.'
    },
    signatureMailingAddress: {
        id: 'tdic.endorsement.mailing-address.By clicking the signature box, I agree to the Terms of Use and confirm the information I have provided is true and accurate.',
        defaultMessage: 'By clicking the signature box, I agree to the {link} and confirm the information I have provided is true and accurate.'
    },
    currentMailingAddress: {
        id: 'tdic.endorsement.mailing-address.Current Mailing Address',
        defaultMessage: 'Current Mailing Address'
    },
    newMailingAddress: {
        id: 'tdic.endorsement.mailing-address.New Mailing Address',
        defaultMessage: 'New Mailing Address'
    },
    changeBoundMessage: {
        id: 'tdic.endorsement.mailing-address.Your request will be completed in a few business days. Please do not submit duplicate changes for this policy.',
        defaultMessage: 'Your request will be completed in a few business days. Please do not submit duplicate changes for this policy.'
    },
    yesNoRadioPrimaryPracticeLocationAddress: {
        id: 'tdic.endorsement.mailing-address.Is this your primary practice location?',
        defaultMessage: 'Is this your primary practice location?'
    },
    noPrimaryPracticeAddress: {
        id: 'tdic.endorsement.mailing-address.By checking this box, I hereby acknowledge this address is used for portal mail purposes only. Your agent will contact you to review your new primary practice location address update.',
        defaultMessage: 'By checking this box, I hereby acknowledge this address is used for portal mail purposes only. Your agent will contact you to review your new primary practice location address update.'
    },
    yesNoRadioPrimaryPracticeLocationAddressYes: {
        id: 'tdic.endorsement.mailing-address.Is this your primary practice location Yes',
        defaultMessage: 'Yes'
    },
    yesNoRadioPrimaryPracticeLocationAddressNo: {
        id: 'tdic.endorsement.mailing-address.Is this your primary practice location No',
        defaultMessage: 'No'
    },
    primaryPracticeLocationAddress: {
        id: 'tdic.endorsement.mailing-address.Primary practice location address',
        defaultMessage: 'Primary practice location address'
    },
    addressLine1P: {
        id: 'platform.inputs.address-details.Address 1 Primary',
        defaultMessage: 'Address 1'
    },
    addressLine2P: {
        id: 'platform.inputs.address-details.Address 2 Primary',
        defaultMessage: 'Address 2'
    },
    cityP: {
        id: 'platform.inputs.address-details.City Primary',
        defaultMessage: 'City'
    },
    stateP: {
        id: 'platform.inputs.address-details.State Primary',
        defaultMessage: 'State'
    },
    postalCodeP: {
        id: 'platform.inputs.address-details.ZIP Code Primary',
        defaultMessage: 'ZIP Code'
    },
    countyFieldP: {
        id: 'platform.inputs.address-details.County Primary',
        defaultMessage: 'County'
    },
    workPhone: {
        id: 'tdic.endorsement.policychange.mailingscreen.workPhone',
        defaultMessage: 'Work Phone'
    },
    officePhone: {
        id: 'tdic.endorsement.policychange.mailingscreen.officePhone',
        defaultMessage: 'Office Phone'
    },
});
